// src/experimentals/chart-radius.mjs

/**
 * @type {Experiment}
 */
export const ChartRadiusExperiment = {
  id: 'chart-radius',
  type: 'chart-styling',
  name: 'borderRadius som standard',
  exclusive: false,          // Tillader at køre sammen med andre styling-eksperimenter
  allowMultiple: true, // 🚨 Tillader eksplicit IKKE at køre flere gange!
  
  /**
   * @param {AppState} appState 
   * @param {string[]} args Parametre sendt med fra URL'en (f.eks. ['20'] eller ['full'])
   * @returns {void}
   */
  init(appState, args = []) {
    const rawValue = args[0];
    if (!rawValue) return;

    // Håndter enten et specifikt tal eller en "full" genvej
    const radius = rawValue === 'full' ? 99 : Number(rawValue);

    console.log(`[Eksperiment] Justerer borderRadius til ${radius}px KUN på sekundære datasæt.`);

    // Registrer en modifier til at transformere arrayet af datasets
    appState.registerModifier('chart:datasets', 
      /**
       * @param {import('chart.js').ChartDataset<'bar'>[]} datasets
       * @returns {import('chart.js').ChartDataset<'bar'>[]}
       */
      (datasets) => {
      return datasets.map((dataset, index) => {
        // datasetIndex 0 er det primære datasæt – det springer vi over
        if (index === 0) {
          return dataset; 
        }

        // Tilføj eller overskriv radius-egenskaberne direkte på det sekundære datasæt
        return {
          ...dataset,
          borderRadius: radius,
          hoverBorderRadius: radius
        };
      });
    });
  }
};